import React from "react";
import FormikCheckBox, {IFormikCheckBoxProps} from "../formikCheckBox/FormikCheckBox";

interface ITermsOfServiceCheckboxProps extends IFormikCheckBoxProps {

}

const TransferableCheckbox = props => {
  return <FormikCheckBox
    name="acceptedTransferable"
    label={'אני מאשר כי השובר הנמצא ברשותי ניתן להעברה'}
  />;
}

TransferableCheckbox.defaultProps = {};

export default React.memo(TransferableCheckbox);
